export default "__VITE_ASSET__Bjri3dAb__"